export default "__VITE_ASSET__Cy2y4Xht__"